<template>
  <div class="form-field form-autocomplete" :rel="name"
       v-bind:class="{'form-required': requiredForm, 'form-focus': focus, 'form-disabled':isDisabled}">
    <div class="form-label" v-show="label">{{ label }}</div>
    <div class="form-hint" v-show="hint">{{ hint }}</div>
    <div class="form-input">
      <div class="form-input-wrapper">
        <div>
          <div>

            <component-multiselect v-model="internalValue"
                                   :show-labels="false"
                                   track-by="id"
                                   :placeholder="labelPlaceholder"
                                   :options="data"
                                   :multiple="isMultiple"
                                   :searchable="true"
                                   :loading="isLoading"
                                   :internal-search="false"
                                   :clear-on-select="true"
                                   :options-limit="300"
                                   :limit="100"
                                   :limit-text="limitText"
                                   :max-height="600"
                                   :show-no-results="onCreate"
                                   :hide-selected="true"
                                   @search-change="asyncFind"
                                   @close="focus = false"
                                   @open="focus = true"
                                   :disabled="isDisabled">
              <template slot="singleLabel" slot-scope="props">
                <div class="field-autocomplete-selectedline">
                  <div class="option__image" v-if="props.option.picture || props.option.icon || iconImage">
                    <img class="image" :src="props.option.picture" v-if="props.option.picture">
                    <span class="icon" v-bind:class="props.option.icon"
                          v-if="props.option.icon && !props.option.picture"></span>
                    <span class="icon" v-bind:class="iconImage" v-if="iconImage && !props.option.picture"></span>
                  </div>
                  <div class="option__desc">
                    <span class="option__title"
                          v-html="(props.option[labelKey] ? props.option[labelKey].escapeHTML() : '') + '<i>'+props.option.id+'</i>'"></span>
                  </div>
                </div>
              </template>
              <template slot="option" slot-scope="props">
                <div class="field-autocomplete-line">
                  <div class="option__image" v-if="props.option.picture || props.option.icon || iconImage">
                    <img class="image" :src="props.option.picture" v-if="props.option.picture">
                    <span class="icon" v-bind:class="props.option.icon"
                          v-if="props.option.icon && !props.option.picture"></span>
                    <span class="icon" v-bind:class="iconImage" v-if="iconImage && !props.option.picture"></span>
                  </div>
                  <div class="option__desc">
                    <span class="option__title"
                          v-html="(props.option[labelKey] ? props.option[labelKey].escapeHTML() : '') + '<i>'+props.option.id+'</i>'"></span>
                    <span class="option__description" v-if="props.option[labelDescription]"
                          v-html="props.option[labelDescription] ? props.option[labelDescription].escapeHTML() : ''"></span>
                  </div>
                </div>
              </template>
              <template slot="tag" slot-scope="props">
                              <span class="multiselect__tag">
                                <span>{{ props.option[labelKey] }}</span>
                                <i aria-hidden="true" tabindex="1" @keydown.enter.prevent="props.remove(props.option)"
                                   @mousedown.prevent="props.remove(props.option)" class="multiselect__tag-icon"></i>
                              </span>
              </template>
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="internalValue"
                     @mousedown.prevent.stop="clearAll(props.search)"></div>
              </template>
              <span slot="noResult" @click="newElement" class="no-result" style="background:#f7f7f7;"><i
                  class="icon icon-icon_expand-circle-plus"></i> Ajouter une entrée</span>
            </component-multiselect>

          </div>
          <div class="bt-action" v-if="!isDisabled">
            <button class="bt-remove" @click="clearAll()" title="Retirer"><i class="icon icon-icon_delete"></i></button>
          </div>
          <div class="bt-action" v-if="onCreate && !isDisabled" title="Créer">
            <button class="bt-new" @click="newElement()"><i class="icon icon-icon_plus"></i></button>
          </div>
          <div class="bt-action" v-if="onDetail && !isDisabled" title="Détail">
            <button class="bt-detail" @click="showDetail()"><i class="icon icon-icon_list"></i></button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: ['value', 'debug', 'label', 'hint', 'name', 'description','placeholder', 'multiple', 'default', 'id', 'service', 'update', 'required', 'callback', 'icon', 'create', 'displayCreate', 'detail', 'displayDetail', 'readonly', 'disabled'],
  data: function () {
    return {
      internalValue: '',
      data: [],
      isLoading: false,
      onDetail: false,
      onCreate: false,
      focus: false
    }
  },
  created: function () {
    this.internalValue = this.value;
    this.isMultiple = this.multiple == 'true' ? true : false;
    this.requiredForm = this.required && this.required == 'true' ? true : false
    this.onChange = this.callback ? true : false;
    this.iconImage = this.icon ? this.icon : null
    this.labelKey = this.name ? this.name : 'name'
    this.labelDescription = this.description ? this.description : 'description'
    this.onCreate = this.displayCreate && (this.displayCreate != 'false' || this.displayCreate != false) ? true : false
    this.onDetail = this.displayDetail && (this.displayDetail != 'false' || this.displayDetail != false) ? true : false
    this.labelPlaceholder = this.placeholder ? this.placeholder : "Rechercher..."
    this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
    this.setDisabled(this.disabled)

    this.setDefault(this.default);

    this.unWatchDefault = this.$watch('default', function (newVal, oldVal) {

      if (newVal != oldVal) {

        if (this.debug) {
          console.log('unWatchDefault', newVal, oldVal)
        }

        this.setDefault(newVal);

      }
    });

    if (this.debug) {
      console.log('created')
    }

  },
  methods: {
    limitText(count) {
      return `and ${count} more`
    },
    asyncFind(query) {
      if (query) {

        this.service.all('?query=' + query).then(response => {
          if (response) {
            this.data = response.data.data ? response.data.data : response.data
          }
        })
      }
    },
    clearAll() {
      this.internalValue = []
    },
    newElement: function () {
      this.create();
    },
    showDetail: function () {
      this.detail();
    },
    setDefault: function (value) {


      if (value && !window._isEmpty(value)) {

        if (this.debug) {
          console.log('setDefault', value)
        }

        let exist = false;
        if (Symbol.iterator in Object(this.options)) {
          for (let item of this.options) {
            if (item.id.toString().toLowerCase() == newVal.toString().toLowerCase()) {
              this.internalValue = item;
              exist = true

              if (this.debug) {
                console.log('setDefault 2', item)
              }
            }
          }
        }

        if (!exist && typeof this.default != "object" && typeof this.default != "array") {

          this.service.all('?id=' + this.default).then(response => {
            if (response && response.data && response.data.length) {

              if (this.debug) {
                console.log("this.service.all", this.default, response.data[0].id);
              }

              this.internalValue = response.data[0]
            }
          })
          if (this.unWatchDefault) {
            this.unWatchDefault();
          }
        }

      }
    },
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'value'(newVal, oldVal) {
      if (newVal !== undefined) {
        this.internalValue = newVal
      }
    },
    'internalValue': {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal && newVal !== undefined) {
          this.$emit('input', this.internalValue);
          if (this.internalValue && this.onChange) {
            this.callback(this.internalValue)
          }
        }
      },
      deep: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/Autocomplete.vue